import script from "./LoaderElement.vue?vue&type=script&setup=true&lang=js"
export * from "./LoaderElement.vue?vue&type=script&setup=true&lang=js"

import "./LoaderElement.vue?vue&type=style&index=0&id=78de0284&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78de0284"]])

export default __exports__